module.exports = __webpack_public_path__ + "img/green-pin.fd26067a.png";